export const skillsFilterables = [
  'level1',
  'level2',
  'level3',
  'skill',
  'wiki_url',
];
